export const headerHeight = 48;
export const footerHeight = 45;
